"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Li = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const Mui_1 = require("../../Mui");
function Li(props) {
    const { sx, ...rest } = props;
    return (0, jsx_runtime_1.jsx)(material_1.Box, { component: "li", ...rest, sx: (0, Mui_1.mergeSxProps)(sx, { display: "list-item" }) });
}
exports.Li = Li;
//# sourceMappingURL=Li.js.map